// Formatos de fecha/hora/número para `d()`/`n()` de vue-i18n. Solo los usa código NUEVO (ver CLAUDE.md).
export const datetimeFormats = {
  es: {
    short: { year: 'numeric', month: 'short', day: 'numeric' },
    long: { year: 'numeric', month: 'long', day: 'numeric', weekday: 'long' },
    time: { hour: '2-digit', minute: '2-digit' }
  }
} as const

export const numberFormats = {
  es: {
    integer: { style: 'decimal', maximumFractionDigits: 0 },
    percent: { style: 'percent', maximumFractionDigits: 1 },
    currency: { style: 'currency', currency: 'MXN' }
  }
} as const
